import { FC } from 'react'
import { Trans } from '@ui/i18n/trans'

import { useLibraryStore } from '@app/web-player/library/state/likes-store';
import { IconButton } from '@ui/buttons/icon-button'

import { FavoriteIcon } from '@ui/icons/material/Favorite'
import { FavoriteBorderIcon } from '@ui/icons/material/FavoriteBorder'

import { useAddItemsToLibrary } from '@app/web-player/library/requests/use-add-items-to-library';
import { useRemoveItemsFromLibrary } from '@app/web-player/library/requests/use-remove-items-from-library';

import { Likeable } from '@app/web-player/library/likeable';
import { Tooltip } from '@ui/tooltip/tooltip'

import { useAuthClickCapture } from '@app/web-player/use-auth-click-capture'
import { Loader2Icon } from 'lucide-react'

export interface LikeButtonProps {
    item: Likeable
}

export const LikeButton: FC<LikeButtonProps> = ({ item }) => {
    const authHandler = useAuthClickCapture()
    const addToLibrary = useAddItemsToLibrary()

    const removeFromLibrary = useRemoveItemsFromLibrary()
    const isLiked = useLibraryStore(s => s.has(item))

    const isLoading = addToLibrary.isPending || removeFromLibrary.isPending

    return (
        <Tooltip delay={0} label={<Trans message={isLiked ? 'Unlike' : 'Like'} />}>
            <IconButton
                className="h-32 w-32"
                disabled={isLoading}
                onClickCapture={authHandler}
                onClick={() => {
                    if (isLiked) {
                        removeFromLibrary.mutate({ likeables: [item] })
                    } else {
                        addToLibrary.mutate({likeables: [item]})
                    }
                }}
            >
                {isLoading ? (
                    <Loader2Icon className="h-24 w-24 animate-spin" />
                ) : isLiked ? (
                    <FavoriteIcon className="h-24 w-24 text-primary" />
                ) : (
                    <FavoriteBorderIcon className="h-24 w-24" />
                )}
            </IconButton>
        </Tooltip>
    )
}
